import React from 'react';

import styles from '~/components/entity-search/entity-search-holder/entity-search-holder.module.scss';

interface Props {
	label: string;
	name: string;
	title?: string;
}

export class EntitySearchHolder extends React.Component<Props> {
	public render() {
		const { label, name, title, children } = this.props;
		return (
			<div className={styles.row}>
				<div className={styles['label-col']}>
					<label htmlFor={name} title={title}>
						{label}
					</label>
				</div>
				<div className={styles['input-col']}>{children}</div>
			</div>
		);
	}
}
